import { useUiStore } from '@/stores/ui-store';
import { CreateSheet } from './create-sheet';
import { EventFormModal } from '@/components/events/event-form-modal';
import { TaskFormModal } from '@/components/tasks/task-form-modal';

export function GlobalModals() {
  const eventFormOpen = useUiStore((s) => s.eventFormOpen);
  const eventInstance = useUiStore((s) => s.eventFormInstance);
  const taskFormOpen = useUiStore((s) => s.taskFormOpen);
  const taskInstance = useUiStore((s) => s.taskFormInstance);

  return (
    <>
      {/* Bottom sheet do FAB (+) */}
      <CreateSheet />
      {/* Modais de formulário — montados por chave para resetar o form a cada abertura */}
      {eventFormOpen && <EventFormModal key={`event-${eventInstance}`} />}
      {taskFormOpen && <TaskFormModal key={`task-${taskInstance}`} />}
    </>
  );
}
